import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 73 50",
    fill: "#1a3646",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path d="M71.7 34.6c-.5-3.4-3.1-6.1-5.6-8.5L45.3 5.7C43.7 4.1 42 2.5 40 1.6c-1.1-.5-2.3-.8-3.5-.8-1.2 0-2.4.3-3.5.8-2 .9-3.7 2.5-5.3 4.1L6.9 26.1c-2.5 2.4-5.1 5.1-5.6 8.5-.6 4 1.8 7.9 4.8 10.6 3.1 2.8 7.5 4.9 11.4 3.5 2.1-.7 3.7-2.3 5.2-3.8 4.6-4.5 9.1-9.1 13.7-13.7 4.6 4.6 9.1 9.2 13.7 13.7 1.5 1.5 3.1 3.1 5.2 3.8 3.9 1.4 8.3-.7 11.4-3.5 3.2-2.7 5.6-6.6 5-10.6z" />' }
  })
);